import Title from 'components/About-Elements/Title/Title'
import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div className="bg-white">
        {/* Hero/Intro Section */}
        <section className="flex flex-col items-center justify-center min-h-[40vh] bg-white p-4 animate__animated animate__fadeIn">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">About Imaginex</h1>
          <p className="text-lg text-gray-700 max-w-2xl text-center mb-6">
            Imaginex operates as a fractional CTO for small business and private clients. We create technical solutions that allow businesses to grow and scale at a competitive rate of large corporations. Never does a small business need to worry about technology being the barrier for them to compete with larger organizations and scale.
          </p>
        </section>

        {/* Core Values Section */}
        <section className="py-12 sm:py-16 bg-gray-50 animate__animated animate__fadeInUp">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">Our Core Values</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center h-full">
                <div className="mb-4 text-[#618A3D]">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m4 0h-1v-4h-1m-4 0h-1v-4h-1m4 0h-1v-4h-1" /></svg>
                </div>
                <h3 className="font-bold text-lg sm:text-xl mb-2">Innovation</h3>
                <p className="text-gray-600 text-sm sm:text-base">We leverage the latest technology and creative thinking to deliver unique solutions for every client.</p>
              </div>
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center h-full">
                <div className="mb-4 text-[#618A3D]">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm0 10c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z" /></svg>
                </div>
                <h3 className="font-bold text-lg sm:text-xl mb-2">Scalability</h3>
                <p className="text-gray-600 text-sm sm:text-base">Our solutions are designed to grow with your business, ensuring long-term success and adaptability.</p>
              </div>
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center h-full">
                <div className="mb-4 text-[#618A3D]">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2h5" /></svg>
                </div>
                <h3 className="font-bold text-lg sm:text-xl mb-2">Partnership</h3>
                <p className="text-gray-600 text-sm sm:text-base">We work closely with our clients, acting as a true partner and extension of your team.</p>
              </div>
              <div className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center h-full">
                <div className="mb-4 text-[#618A3D]">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm0 10c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z" /></svg>
                </div>
                <h3 className="font-bold text-lg sm:text-xl mb-2">Affordability</h3>
                <p className="text-gray-600 text-sm sm:text-base">We provide enterprise-level solutions at a price point accessible to small businesses and private clients.</p>
              </div>
            </div>
          </div>
        </section>

        {/* How We Work Section */}
        <section className="py-16 bg-white animate__animated animate__fadeInLeft">
          <div className="max-w-5xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 flex justify-center">
              <img src="/images/plan.jpg" alt="How We Work" className="rounded-xl shadow-lg w-full max-w-md" />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">How We Work</h2>
              <ol className="space-y-4 list-decimal list-inside text-gray-700">
                <li><span className="font-semibold text-[#618A3D]">Consult:</span> We listen to your needs and goals to craft a tailored strategy.</li>
                <li><span className="font-semibold text-[#618A3D]">Build:</span> Our team develops robust, scalable solutions using best-in-class technology.</li>
                <li><span className="font-semibold text-[#618A3D]">Support:</span> We provide ongoing support and optimization to ensure your continued success.</li>
                <li><span className="font-semibold text-[#618A3D]">Scale:</span> As your business grows, we help you scale your technology seamlessly.</li>
              </ol>
            </div>
          </div>
        </section>

        {/* Mission/Title Section */}
        <Title/>



        {/* Call to Action Section */}
        <section className="py-12 sm:py-16 bg-[#618A3D] animate__animated animate__fadeIn">
          <div className="max-w-2xl mx-auto text-center px-4">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">Ready to Grow With Imaginex?</h2>
            <p className="text-base sm:text-lg text-white mb-8">Let’s discuss how we can help your business scale and succeed. Reach out for a free consultation today.</p>
                            <a href="mailto:theimaginexcompany@gmail.com" className="inline-block px-8 py-4 bg-white text-[#618A3D] font-bold rounded-lg shadow-lg hover:bg-gray-100 transition">Contact Us</a>
          </div>
        </section>
      </div>
    )
  }
}
